import * as React from 'react'
import {connect} from 'react-redux'
import {bindActionCreators} from 'redux'

import {FormattedMessageWrapper} from '@daedalus/core/src/localization/components/FormattedMessage'

import ErrorBlock from 'components/presentational/ErrorBlock'

import {fatalError} from 'modules/common/actions/fatalError'

type PropsType = {
  children: React.ReactNode
  fatalError: (error: Error, errorInfo: any) => null
}

class UnknownErrorBoundary extends React.PureComponent<PropsType> {
  static getDerivedStateFromError() {
    return {error: true}
  }

  state = {error: null, errorInfo: null}

  componentDidCatch(error, errorInfo) {
    this.props.fatalError(error, errorInfo)
  }

  render() {
    if (this.state.error) {
      return (
        <ErrorBlock
          heading={
            <FormattedMessageWrapper
              id="unknown-error-boundary-message"
              defaultMessage="Something went wrong"
            />
          }
        >
          <FormattedMessageWrapper
            id="unexpected-error-occurred"
            defaultMessage="An unexpected error occurred."
          />
        </ErrorBlock>
      )
    }

    return this.props.children
  }
}

const mapDispatchToProps = (dispatch: any) =>
  bindActionCreators({fatalError}, dispatch)

export default connect(null, mapDispatchToProps)(UnknownErrorBoundary)
